import { Component, Input } from '@angular/core';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';

@Component({
  selector: 'app-contract-product-list',
  templateUrl: './contract-product-list.component.html',
  styleUrl: './contract-product-list.component.scss'
})
export class ContractProductListComponent {
  @Input() ContractProductList!: DtoContractClientForViewVM[];
  constructor(private router: Router, private auth: AuthService) { }

  ngOnInit() {
    if (!this.auth.isAuthenticated([UserType.Workshop,UserType.Gallery])) {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetContractDetails(ContractId?: number) {
    this.router.navigateByUrl('dashboard/contract-details/' + ContractId);
  }
}
